import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(
    videoUrl: string,
    isYoutube?: boolean,
    isVimeo?: boolean,
  ): SafeResourceUrl {
    let url = videoUrl || '';

    if (isYoutube) {
      url = this.getEmbedYoutubeUrl(videoUrl);
    }

    if (isVimeo) {
      url = this.getEmbedVimeoUrl(videoUrl);
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public getEmbedYoutubeUrl(videoUrl: string): string {
    let url = videoUrl || '';

    if (url?.includes('watch?v=')) {
      url = videoUrl.replace('watch?v=', 'embed/');
    }

    if (url?.includes('.be/')) {
      url = videoUrl.replace('.be/', 'be.com/embed/');
    }

    if (url?.lastIndexOf('?')) {
      url = url.split('?')[0];
    }

    return url;
  }

  public getEmbedVimeoUrl(videoUrl: string): string {
    let url = videoUrl || '';

    if (url?.lastIndexOf('?')) {
      url = url.split('?')[0];
    }

    const strings = url.split('/');

    if (strings?.length) {
      url = 'https://player.vimeo.com/video/' + strings[strings.length - 1];
    }

    return url;
  }
}
